import $ from 'jquery';
import { Swiper, Pagination } from 'swiper';
import HideOffscreenSlides from '../../components/modules/swiper-hide-offscreen';

$(document).ready(() => {
  const blogList = $('.blog-list__link');
  const blogListFirstEl = blogList.first().data('image');

  blogList.first().addClass('active');
  blogList.closest('.blog-list__background').find('.blog-list__image img').attr('src', blogListFirstEl);

  blogList.on('mouseenter', function () {
    blogList.removeClass('active');
    $(this).addClass('active');

    const dataImage = $(this).data('image');
    const altForImage = $(this).find('span').text();
    const imageEl = $(this).closest('.blog-list__background').find('.blog-list__image img');

    imageEl.attr('src', dataImage);
    imageEl.attr('alt', altForImage);
  });

  // eslint-disable-next-line no-new
  new Swiper('.blog-list__swiper-container', {
    modules: [Pagination, HideOffscreenSlides],
    speed: 700,
    slidesPerView: 1,
    autoHeight: true,
    spaceBetween: 22,
    preloadImages: true,
    pagination: {
      el: '.blog-list__swiper-pagination',
      type: 'bullets',
    },
  });
});
